import { ReactNode } from 'react';
import { ContentHeader, ContentHeaderType } from './ContentHeader/ContentHeader';
import { ContentLayoutMain, ContentWrapper, BannerWrapper, ContentLayoutWrapper } from './styles';
import { ResponseErrorType } from '@/types/sharedTypes';
import { NoContentLayout } from './NoContentLayout/NoContentLayout';
import { TopHeader } from './TopHeader/TopHeader';

type ContentLayoutType = {
  children?: ReactNode;
  banner?: ReactNode;
  apiError?: ResponseErrorType;
  breadcrumbs?: ReactNode;
} & ContentHeaderType;

export const ContentLayout = (props: ContentLayoutType) => {
  const { children, banner, apiError, breadcrumbs, ...rest } = props;

  return (
    <>
      {banner && <BannerWrapper>{banner}</BannerWrapper>}

      <ContentLayoutWrapper>
        <TopHeader breadcrumbs={breadcrumbs || props.title}></TopHeader>
        <ContentLayoutMain>
          <ContentHeader {...rest} />
          <ContentWrapper>
            {apiError ? (
              <NoContentLayout apiError={apiError} backButton={props.backButton} onBack={props.onBack} />
            ) : (
              children
            )}
          </ContentWrapper>
        </ContentLayoutMain>
      </ContentLayoutWrapper>
    </>
  );
};
